/**
 * 通用权限检查方法
 * Common check permissions method
 * @param { 需要的权限 | Permission judgment } permissions
 * @param { 你当前的权限 | Your permission description } currentAuthority
 */

// const checkPermissions = (currentAuthority, permissions) => {
//   if (Array.isArray(permissions) && permissions.length <= 0) {
//     return true;
//   }

//   if (!permissions) {
//     return true;
//   }

//   if (Array.isArray(currentAuthority)) {
//     return currentAuthority.some((item) => permissions.includes(item))
//   }

//   if (typeof currentAuthority === 'string') {
//     return permissions.includes(currentAuthority);
//   }

//   if (typeof currentAuthority === 'function') {
//     return currentAuthority(permissions);
//   }

//   throw new Error('[react-acl-router]: Unsupport type of currentAuthority.');
// };

const checkPermissions = (currentAuthority, permissions) => {
  if (Array.isArray(permissions) && permissions.length <= 0) {
    return true;
  }

  if (!permissions) {
    return true;
  }

  if (Array.isArray(permissions)) {
    if (Array.isArray(currentAuthority)) {
      return currentAuthority.some((item) => permissions.includes(item));
    } else {
      return permissions.includes(currentAuthority);
    }
  }

  if (typeof permissions === 'string') {
    if (Array.isArray(currentAuthority)) {
      return currentAuthority.some((item) => permissions === item);
    } else {
      return permissions === currentAuthority;
    }
  }
}

export default checkPermissions;
